import AncientBow from './Eqp_Arcane_Umbra_Ancient_Bow.webp'
import ArmCannon from './Eqp_Arcane_Umbra_Ellaha.webp'

import Bladecaster from './Eqp_Arcane_Umbra_Bladecaster.webp'
import Bow from './Eqp_Arcane_Umbra_Bow.webp'

import Cane from './Eqp_Arcane_Umbra_Cane.webp'
import CelestialLight from './Eqp_Arcane_Umbra_Celestial_Light.png'
import Chain from './Eqp_Arcane_Umbra_Chain.webp'
import Chakram from './Eqp_Arcane_Umbra_Chakram.webp'
import Claw from './Eqp_Arcane_Umbra_Guards.webp'
import Crossbow from './Eqp_Arcane_Umbra_Crossbow.webp'

import Dagger from './Eqp_Arcane_Umbra_Dagger.webp'
import Desperado from './Eqp_Arcane_Umbra_Desperado.webp'
import DualBowguns from './Eqp_Arcane_Umbra_Dual_Bowguns.webp'

import Fan from './Eqp_Arcane_Umbra_Fan.webp'

import Gun from './Eqp_Arcane_Umbra_Pistol.webp'

import HandCannon from './Eqp_Arcane_Umbra_Siege_Gun.webp'
import HeavySword from './Eqp_Lapis_Type_9.webp'

import IllusorySword from './Eqp_Arcane_Umbra_Illusory_Sword.png'

import Katana from './Eqp_Arcane_Umbra_Katana.webp'
import Katara from './Eqp_Arcane_Umbra_Katara.webp'
import Knuckle from './Eqp_Arcane_Umbra_Knuckle.webp'

import LongSword from './Eqp_Lazuli_Type_9.webp'
import LucentGauntlet from './Eqp_Arcane_Umbra_Lucent_Gauntlet.webp'

import MemorialStaff from './Eqp_Arcane_Umbra_Memorial_Staff.png'

import OneHandedAxe from './Eqp_Arcane_Umbra_Axe.webp'
import OneHandedHammer from './Eqp_Arcane_Umbra_Hammer.webp'
import OneHandedSword from './Eqp_Arcane_Umbra_Saber.webp'

import Polearm from './Eqp_Arcane_Umbra_Polearm.webp'
import PsyLimiter from './Eqp_Arcane_Umbra_Psy-limiter.webp'

import RitualFan from './Eqp_Arcane_Umbra_Super_Ritual_Fan.webp'

import Scepter from './Eqp_Arcane_Umbra_Scepter.webp'
import ShiningRod from './Eqp_Arcane_Umbra_Shining_Rod.webp'
import SoulShooter from './Eqp_Arcane_Umbra_Soul_Shooter.webp'
import Spear from './Eqp_Arcane_Umbra_Spear.webp'
import Staff from './Eqp_Arcane_Umbra_Staff.webp'

import TwoHandedAxe from './Eqp_Arcane_Umbra_Two-handed_Axe.webp'
import TwoHandedHammer from './Eqp_Arcane_Umbra_Two-Handed_Hammer.webp'
import TwoHandedSword from './Eqp_Arcane_Umbra_Two-handed_Sword.webp'

import Wand from './Eqp_Arcane_Umbra_Wand.webp'
import WarFist from './Eqp_Arcane_Umbra_War_Fist.webp'
import WhipBlade from './Eqp_Arcane_Umbra_Energy_Chain.webp'
import Whispershot from './Eqp_Arcane_Umbra_Whispershot.webp'

// Assets taken from https://maplestorywiki.net

export default {
  AncientBow,
  ArmCannon,
  Bladecaster,
  Bow,
  Cane,
  CelestialLight,
  Chain,
  Chakram,
  Claw,
  Crossbow,
  Dagger,
  Desperado,
  DualBowguns,
  Fan,
  Gun,
  HandCannon,
  HeavySword,
  IllusorySword,
  Katana,
  Katara,
  Knuckle,
  LongSword,
  LucentGauntlet,
  MemorialStaff,
  OneHandedAxe,
  OneHandedHammer,
  OneHandedSword,
  Polearm,
  PsyLimiter,
  RitualFan,
  Scepter,
  ShiningRod,
  SoulShooter,
  Spear,
  Staff,
  TwoHandedAxe,
  TwoHandedHammer,
  TwoHandedSword,
  Wand,
  WarFist,
  WhipBlade,
  Whispershot
}
